import {
    Store
} from 'vuex';
import {
    IGlobalState
} from '@/store';
import * as Types from '@/store/action-types';

/**
 * 根据应用id获取应用下已申请API列表
 */
export async function useAppAuthedAPI(store: Store<IGlobalState>, userId: string,appId: any, examineState: number,keyWord: string,page: number, limit: number) {
    await store.dispatch(`apiManage/${Types.SET_APPLICATION_AUTHED_API_LIST}`,
        {
            userId:userId,
            appId:appId,
            examineState:examineState === -1 ? '':examineState,
            keyWord: keyWord,
            page: page,
            limit: limit
        });
};

/**
 * 使用接口列表
 */
export async function useAPIList(store: Store<IGlobalState>,appId: string,groupId: string,keyWord: string,page: number,limit: number) {
    await store.dispatch(`apiManage/${Types.SET_APPLICATION_API_LIST}`,
        {
            appId:appId,
            groupId:groupId,
            keyWord: keyWord,
            page: page,
            limit: limit
        });
};

/**
 * 使用api分组列表
 */
export async function useApiGroupList(store: Store<IGlobalState>) {
    await store.dispatch(`apiManage/${Types.SET_APPLICATION_API_GROUP_LIST}`);
};